import type { Concept } from '@/shared/types';
import type { Table } from 'dexie';
import Dexie from 'dexie';

export class EMRDatabase extends Dexie {
  concepts!: Table<Concept>;

  constructor() {
    super('emr-db');

    this.version(1).stores({
      concepts: `
        uuid,
        display,
        set,
        retired,
        datatype.uuid,
        *names.display,
        conceptClass.uuid,
        conceptClass.display
      `,
    });
  }
}

export const db = new EMRDatabase();
